module.exports = __webpack_public_path__ + "assets/svg/socialIcons/fb-icon-blue.svg";